export const SIMPLE_TEE_TIMES_DEFAULT_VALUE = 7;
export const SIMPLE_TEE_TIMES_ARRIVAL_DEFAULT_VALUE = 12;
export const SIMPLE_TEE_TIMES_WEEKEND_DEFAULT_VALUE = 10;

export const SIMPLE_TEE_TIMES_OPTIONS: Record<string, string> = {
  "7": "07:00 - 09:00",
  "9": "09:00 - 11:00",
  "11": "11:00 - 13:00",
  "13": "13:00 - 15:00",
};

export const SIMPLE_TEE_TIMES_WEEKEND_OPTIONS: Record<string, string> = {
  "10": "10:00 - 12:00",
  "12": "12:00 - 15:00",
};

export const SIMPLE_TEE_TIMES_ARRIVAL_DAY_OPTIONS: Record<string, string> = {
  "12": "12:00 - 15:00",
};

export const SIMPLE_TEE_TIMES_PRODUCT_CODE_RESTRICTION = ["YGTUKI"];
